import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useInputKeys from "hooks/useInputKeys";
import Box from "@mui/material/Box";
import BackButtonImage from "assets/images/backButton.png";
import GameDescription from "./GameDescription";
import PlayGame from "./PlayGame";
import { useHistoryGuessNumber } from "hooks/game";
import loading from "assets/images/loading_gif.json";
import Lottie from "lottie-react";
import "./index.scss";

function GuessNumber({ handleBack, setSelectedGame }) {
  const { t } = useTranslation();
  const { direction } = useInputKeys();
  const [step, setStep] = useState(1);
  const [hasWon, setHasWon] = useState(false);
  const { mutate: historyGuessNumber, isLoading } = useHistoryGuessNumber();
  const [history, setHistory] = useState();
  const [tries, setTries] = useState();
  const [goldenNumber, setGoldenNumber] = useState();
  const [currentScore, setCurrentScore] = useState();

  useEffect(() => {
    historyGuessNumber(
      {},
      {
        onSuccess: (data) => {
          if (data?.status === "OK") {
            setHistory(data);
          }
        },
        onError: (e) => {
          console.error("Guess failed:", e);
        },
      }
    );
  }, [historyGuessNumber]);

  const handleStep = () => {
    if (step === 1) {
      handleBack(null);
    } else {
      setStep(step - 1);
    }
  };

  const handleReturn = () => {
    setStep(step - 1);
    setSelectedGame(null);
  };

  const handleNext = () => {
    setStep(step + 1);
  };

  const handleLunchGame = () => {
    setStep(step + 1);
  };

  const stepComponents = {
    1: <GameDescription handleNext={handleLunchGame} history={history} />,
    2: (
      <PlayGame
        handleNext={handleNext}
        setHasWon={setHasWon}
        history={history}
        setTries={setTries}
        setGoldenNumber={setGoldenNumber}
        setCurrentScore={setCurrentScore}
      />
    ),
  };

  return (
    <Box className="guess-number-game-component">
      {isLoading ? (
        <Lottie animationData={loading} loop={true} />
      ) : (
        <>
          {hasWon ? (
            <Box className={`true-event ${direction}`}>
              <Box className="true-guess">
                {goldenNumber}
                <Box className="score">+{currentScore}</Box>
              </Box>
              <Box className="description">
                {t("FoundCodeinTries", { count: tries })}
              </Box>
              <Box className="return-button">
                <button onClick={handleReturn}>{t("return")}</button>
              </Box>
            </Box>
          ) : (
            <Box
              className={`guess-number-wrapper ${
                step === 1 ? "" : "linearBackGround"
              }`}
            >
              <Box className="button-box">
                <Box className="back-button" onClick={handleStep}>
                  <img
                    src={BackButtonImage}
                    alt="Back Button"
                    className={direction}
                  />
                  <span className={`${direction}`}>{t("guessNumber")}</span>
                </Box>
              </Box>
              <Box className="step-box">{stepComponents[step] || null}</Box>
            </Box>
          )}
        </>
      )}
    </Box>
  );
}

export default GuessNumber;
